<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div class="Dtunes__workforce__main">
                        <h2>The Dtunes Workforce</h2>
                        <p>Below are the teams you have created</p>
                    </div>
                    <v-spacer></v-spacer>
                    <createworkforce-modal @team-created="getTeams"/>
                </v-row>
                <dtunes-loader :loading="loading"></dtunes-loader>
                <workforce-cards :teams="teams" @add-member="getTeams"/>
                
                <dtunes-empty v-if="teams.length == 0 && this.loading == false">
                    <template v-slot:title>
                        No Team created yet
                    </template>
                    <template v-slot:sub-title>
                        Click on the create New Team button to create a Team
                    </template>
                </dtunes-empty>
                <!-- <div v-if="teams.length == 0" class="text-center">
                    <h2>No created Teams</h2>
                </div> -->
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
// ============= IMPORT COMPONENTS ===============
import CreateworkforceModal from "../../components/create-workforce-modal.vue"
import WorkforceCards from "../../components/workforce-cards.vue"
import DtunesLoader from "@/components/dtunes-loader.vue"
import DtunesEmpty from "@/components/dtunes-empty.vue"

// =========== IMPORT SERVICE ==============
import { TeamService } from "@/services";

export default {
    components:{
        CreateworkforceModal,
        WorkforceCards,
        DtunesLoader,
        DtunesEmpty
    },
    data: () => ({
    teams:[],
    loading:false
    }),
    mounted(){
        this.getTeams();
    },
    methods:{
        async getTeams(){
            try {
                this.loading = true
                const data = await TeamService.getTeams();
                this.loading = false
                this.teams = data;  
            } catch (error) {
                console.log(error);
            }
            
        }
    }

}
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";
</style>